import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap, withLatestFrom } from 'rxjs/operators';
import { TwoColumnLayoutService } from 'src/app/common-components/column-layouts/two-column-list-layout/services/selected-id.service';
import { LcsDialogService } from 'src/app/common-components/dialog/dialog.service';
import { getSelectedAccountId } from 'src/app/store/select-account/select-account.selector';
import { ScheduleDetailSaveModel } from '../../schedule-details/models/schedule-detail-save.model';
import { AddScheduleApiService } from '../services/add-schedule-api.service';
import * as AddScheduleActions from './add-schedule.actions';

@Injectable()
export class AddScheduleEffects {
   createSchedule$ = createEffect(() => {
      return this.actions$.pipe(
         ofType(AddScheduleActions.createSchedule),
         withLatestFrom(this.store.select(getSelectedAccountId)),
         switchMap(([action, accountId]) => {
            const scheduleToSave: ScheduleDetailSaveModel = {
               ...action.schedule,
               accountId: accountId ?? 0,
            };
            return this.addScheduleApiService.create(scheduleToSave).pipe(
               map((executionResult) => {
                  return AddScheduleActions.createScheduleSuccess({
                     scheduleId: executionResult.data.schedule.scheduleId,
                     scheduleName: executionResult.data.schedule.name,
                  });
               }),
               catchError((error) => {
                  return of(AddScheduleActions.createScheduleFailure(error));
               })
            );
         })
      );
   });

   createScheduleSuccess$ = createEffect(
      () => {
         return this.actions$.pipe(
            ofType(AddScheduleActions.createScheduleSuccess),
            tap((result) => {
               this.dialogService.closeFormComponent();
               // Call newItemAdded to set selectedId to new scheduleId and notify register component of new item (will refresh list)
               this.twoColumnLayoutService.newItemAdded(result.scheduleId);
               this.snackbar.open(`Schedule ${result.scheduleName} Created`);
            })
         );
      },
      {
         dispatch: false,
      }
   );

   constructor(
      private actions$: Actions,
      private addScheduleApiService: AddScheduleApiService,
      private store: Store,
      private snackbar: MatSnackBar,
      private dialogService: LcsDialogService,
      private twoColumnLayoutService: TwoColumnLayoutService
   ) {}
}
